<script setup lang="ts">
/**
 * ColorblindFilters — definições SVG para filtros de daltonismo.
 *
 * Renderizado uma única vez no root do app; referenciado por CSS via
 * `filter: url("#hlos-filter-X")`. Não é interativo; serve apenas para
 * carregar os filtros no DOM.
 *
 * Constitucional:
 * - P-UX-04: filtro é opt-in (só aplica se preference.colorblindMode != "none").
 * - Princípio X: respeito à percepção visual de cada aprendiz.
 */
</script>

<template>
  <!--
    Filtros SVG para daltonismo. Matrizes baseadas em padrões de
    simulação de daltonismo (Brettel et al. 1997) e ajustes práticos
    para a paleta do HLOS. Não são perfeitos — não substituem
    correção ótica real — mas reduzem confusão cromática.
  -->
  <svg
    class="hlos-colorblind-filters"
    aria-hidden="true"
    focusable="false"
    width="0"
    height="0"
    style="position: absolute; width: 0; height: 0; overflow: hidden"
  >
    <defs>
      <filter id="hlos-filter-protanopia">
        <feColorMatrix
          type="matrix"
          values="0.567 0.433 0     0 0
                  0.558 0.442 0     0 0
                  0     0.242 0.758 0 0
                  0     0     0     1 0"
        />
      </filter>
      <filter id="hlos-filter-deuteranopia">
        <feColorMatrix
          type="matrix"
          values="0.625 0.375 0   0 0
                  0.7   0.3   0   0 0
                  0     0.3   0.7 0 0
                  0     0     0   1 0"
        />
      </filter>
      <filter id="hlos-filter-tritanopia">
        <feColorMatrix
          type="matrix"
          values="0.95 0.05  0     0 0
                  0    0.433 0.567 0 0
                  0    0.475 0.525 0 0
                  0    0     0     1 0"
        />
      </filter>
    </defs>
  </svg>
</template>

<style scoped>
.hlos-colorblind-filters {
  display: none;
}
</style>
